module.exports = "<md-dialog class=\"loading-dialog dialog-background-white\"><div class=\"loader-indicator\"></div></md-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/views/loadingDialogWhitebackground.pug
// module id = 689
// module chunks = 0